export const RISK_COUNTRY_COLUMNS = [
  { columnName: 'Country', key: 'Description' },
  { columnName: 'Risk', key: 'Param1' },
  { columnName: 'Reason', key: 'Comments' },
];
